module.exports = __webpack_public_path__ + "img/ec.5d6fdbf8.svg";